// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setTransitionAnalyses = createAction('[Custom PDF Report Modal] Set Transition Analyses', props());
